import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateSiteDocumentsCache,
  SiteDocumentsCacheEvents,
} from '@monorepo/shared/cacheRegisters/documents/siteDocumentsCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseDeleteSiteDocumentParams = {
  config?: MutationConfig<void, Api.ErrorResponse>;
};

export const useDeleteSiteDocument = (params?: UseDeleteSiteDocumentParams) =>
  useMutation(Api.deleteProjectDocument, {
    ...params?.config,
    onSuccess: (data, vars) => {
      invalidateSiteDocumentsCache(SiteDocumentsCacheEvents.DELETE, {
        organizationId: vars.organizationId,
        projectId: vars.projectId,
      });
      return params?.config?.onSuccess?.(data, vars);
    },
  });
